import { render, staticRenderFns } from "./ConfigTouTab.vue?vue&type=template&id=230f7e16"
import script from "./ConfigTouTab.vue?vue&type=script&lang=ts"
export * from "./ConfigTouTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports